module.exports = __webpack_public_path__ + "static/media/photo30.5d15521a.jpg";